import { Component } from '@angular/core';
import { SlideBaseComponent } from '../slide-base/slide-base.component';
import { SlideTypeEnum } from '../../enums/slide-type';
import { SpeechRuleEngineService } from 'src/app/modules/math-text/services/speech-rule-engine.service';
import { ExpandedContentService } from 'src/app/modules/expandable-content/services/expanded-content.service';

@Component({
  selector: 'htc-slide-chart',
  templateUrl: './slide-chart.component.html',
  styleUrls: ['./slide-chart.component.scss'],
  standalone: false,
})
export class SlideChartComponent extends SlideBaseComponent {
  isChartOpen = false;
  type = SlideTypeEnum.chartSlide;

  constructor(
    private expandedContentService: ExpandedContentService,
    public sres: SpeechRuleEngineService
  ) {
    super();
  }
}
